import React from 'react';

const NotFound = () => {
    return (
        <div>
            
              <h1>404</h1>
            <h2>The Page you are Looking for is currently Unavailable or not exists</h2>
            <img src="https://www.pngitem.com/pimgs/m/561-5616833_image-not-found-png-not-found-404-png.png" alt="" />
        </div>
    );
};

export default NotFound;